import React from 'react'

const Open = () => {
  return (
    <div className='row-start-2 bg-drk00 h-full overflow-auto flex justify-center items-center'>
        <p className=' text-4xl font-poppins font-semibold text-drk01'>
            Open a tab to view
        </p>

    </div>
  )
}

export default Open